export class draftReportUrl {
    DELETE_DRAFT_SIGNATURE_URL = "sig/v1/draft-signature/";
    GET_DRAFT_SIGNATURES_URL = "sig/v1/draft-signature/all[?Name][&ClientId][&AssignedTo][&UploadedAfterDate][&DocumentType][&TaxYear][&PageSize][&PageNumber][&SortOrder][&SortBy]";
}